import { render, staticRenderFns } from "./VisualizarElementoPrimarioConsolidado.vue?vue&type=template&id=76e564b4&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./VisualizarElementoPrimarioConsolidado.vue?vue&type=style&index=0&id=76e564b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e564b4",
  null
  
)

export default component.exports